import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { isHrefOrOnClickRequired } from './propTypes';

export default function OutlinedButton({
  children,
  className,
  color,
  disabled = false,
  onDark = false,
  size,
  type = 'button',
  ...restProps
}) {
  const attributes = {
    className: classNames(
      'tw-apply-outlined-button',
      onDark ?
        'tw-apply-outlined-button--on-dark'
      : 'tw-apply-outlined-button--on-light',
      {
        [`tw-apply-outlined-button--${size}`]: !!size,
        [`tw-apply-outlined-button--${color}`]: !!color,
      },
      className,
    ),
    ...restProps,
  };

  return restProps.href ?
      <a {...attributes} data-disabled={disabled}>
        {children}
      </a>
    : <button {...attributes} disabled={disabled} type={type}>
        {children}
      </button>;
}

OutlinedButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(['blue-grey', 'red', 'grey', 'white']),
  disabled: PropTypes.bool,
  href: isHrefOrOnClickRequired,
  onClick: isHrefOrOnClickRequired,
  onDark: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  type: PropTypes.string,
};
